import PageIframe from 'components/PageIframe';
import React from 'react';

interface PageViewerProps {
  pageId: string;
}

const PageAppLanding: React.FC<PageViewerProps> = ({ pageId }) => {
  return (
    <div style={{ 
      width: '100%', 
      height: '100%',
      display: 'flex',
      flex: 1
    }}>
      <PageIframe pageId={pageId} />
    </div>
  );
};

export default PageAppLanding;
